import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import "../App.css";
import "../bootstrap.css";
import { Icons } from "../features/theme";
import { environment } from "../constants";
import { checkForLettersOnly } from "../helpers/helper";

const menuItems = [
  { item: "Find trials", url: "/results?q=&in=UNITED%20STATES" },
  { item: "Sponsors", url: "https://patientrials.com/" },
  { item: "About", url: "https://patientrials.com/about/" },
  // { item: "Blog", url: "/blog" },
];

const signUp = () => {
  localStorage.setItem("currentPage", window.location.href);
  window.location.href = `/enroll/${
    environment === "PROD" ? "STU01009" : environment === "DEV" ? "STU0001002" : "STU01006"
  }`;
};

const Header = (props) => {
  const { showHeader } = props;
  const location = useLocation();
  const itemClick = (name) => {
    setClickedItem(name);
  };
  const [clickedMenuItem, setClickedItem] = useState("");
  const MenuItem = (i, url, itemName, activeState) => {
    return (
      <li
        key={i}
        onClick={() => itemClick(itemName)}
        className={
          itemName === clickedMenuItem ? "nav-item active" : activeState
        }
      >
        <a href={url} className="nav-link">
          {itemName}
        </a>
      </li>
    );
  };

  return (
    <div style={{ display: `${showHeader === false && "none"}` }}>
      <div className="menubar container-fluid">
        <nav className="navbar navbar-expand-lg container">
          <a href="/">
            {(location && location.pathname === "/kira") ||
            (location && location.pathname === "/KIRA") ||
            (location && location.pathname === "/vlu") ||
            (location && location.pathname === "/VLU") ||
            (location && location.pathname === "/mosaic") ||
            (location && location.pathname === "/MOSAIC") ? (
              <img
                className="navbar-brand logo"
                style={{ height: 50 }}
                alt="logo"
                src={Icons.indegeneLogo}
              ></img>
            ) : (
              <img
                className="navbar-brand logo"
                alt="logo"
                src={Icons.logo}
              ></img>
            )}
          </a>
          <button
            className="navbar-toggler"
            data-toggle="collapse"
            data-target="#menu"
          >
            <span className="navbar-toggler-icon">
              <img src={Icons.list} alt="header menu icon"></img>
            </span>
          </button>
          <div id="menu" className="collapse navbar-collapse">
            {environment === "DEV" ? (
              <p className="mb-0 mx-2" style={{ color: "darkorange" }}>
                Preview
              </p>
            ) : environment === "STAGING" ? (
              <p className="mb-0 mx-2" style={{ color: "darkorange" }}>
                Demo
              </p>
            ) : null}
            <ul className="navbar-nav ml-auto">
              {menuItems.map((menuitem, i) =>
                MenuItem(i, menuitem.url, menuitem.item, "nav-item")
              )}
            </ul>
            <button
              onClick={() => signUp()}
              rel="noopener noreferrer"
              className="signin btn btn-danger btn-lg ml-2"
              target="_blank"
            >
              SIGN UP
            </button>
          </div>
        </nav>
      </div>
    </div>
  );
};

export default Header;
